import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../axiosConfig";
import "./Login.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Formatear los datos como URL encoded
      const formData = new URLSearchParams();
      formData.append("username", username);
      formData.append("password", password);

      // Llamar al backend FastAPI
      const response = await api.post("/auth/login", formData, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      // Guardar token
      localStorage.setItem("token", response.data.access_token);

      // Guardar usuario básico (opcional)
      localStorage.setItem("user", JSON.stringify({ nombre_usuario: username }));

      // Redirigir
      navigate("/calendario");

    } catch (error) {
      console.error(error);
      alert(error.response?.data?.detail || "Usuario o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card shadow-lg">
        <div className="text-center mb-4">
          <img src="/logo_empresa.png" alt="Logo empresa" className="login-logo" />
        </div>

        <h4 className="text-center mb-3 text-primary">Iniciar Sesión</h4>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Usuario"
            className="form-control mb-3"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="password"
            placeholder="Contraseña"
            className="form-control mb-3"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
